<app-loader *ngIf="isLoading; else elseTemplate"></app-loader>
<ng-template #elseTemplate>
  <form [formGroup]="formDetails">
    <app-requestor-form
      *ngIf="requesterConfig"
      [formDetails]="getFormControl('requester')"
      formGroupName="requester"
      [config]="requesterConfig.elementConfigList"
      (confirmCallback)="updateRequestorInRiderTable()"
      [reqTypeMapping]="reqRiderDropdown"
      [referenceBooking]="referenceBooking">
    </app-requestor-form>
    
    <ng-template #oldRiderTable>
      <app-riders-table
      *ngIf="riderConfig && reqRiderDropdown?.length"
      [bookingEditConfig]="bookingEditConfig"
      [formArray]="getFormControl('riders')"
      [tripFormDetails]="tripFormDetails"
      formArrayName="riders"
      [config]="riderConfig"
      [requester]="requester"
      [enableAlternateMobileNumber]="miscelleneousConfig.enableAlternateMobileNumber"
      [whatsappComm]="miscelleneousConfig.enableWhatsAppNotification"
      [riderTypeMapping]="reqRiderDropdown"
      [referenceBooking]="referenceBooking"
      [miscelleneousConfig]="miscelleneousConfig"
      >
    </app-riders-table>
    </ng-template>
    <app-new-rider-table *ngIf="miscelleneousConfig?.newRiderTable  && reqRiderDropdown?.length; else oldRiderTable"
    [config]="riderConfig"
    [whatsappComm]="miscelleneousConfig.enableWhatsAppNotification"
    [referenceBooking]="referenceBooking"
    [formArray]="getFormControl('riders')"
    formArrayName="riders"
    [bookingEditConfig]="bookingEditConfig"
    [tripFormDetails]="tripFormDetails"
    [requester]="requester"
    [miscelleneousConfig]="miscelleneousConfig"
    [riderTypeMapping]="reqRiderDropdown"
    >

    </app-new-rider-table>

  </form>
</ng-template>

